export const getTimeAgoString = (timestamp: number) => {
  const now = Math.floor(Date.now() / 1000);
  const seconds = now - Math.floor(timestamp / 1000);

  const minute = 60;
  const hour = 60 * minute;
  const day = 24 * hour;

  if (seconds < minute) {
    return 'Recently';
  } else if (seconds < hour) {
    const minutes = Math.floor(seconds / minute);
    return `${minutes} ${minutes === 1 ? 'min' : 'min'} ago`;
  } else if (seconds < day) {
    const hours = Math.floor(seconds / hour);
    return `${hours} ${hours === 1 ? 'hr' : 'hr'} ago`;
  } else {
    const date = new Date(timestamp);
    const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: '2-digit', day: '2-digit' };
    const dateFormatter = new Intl.DateTimeFormat(undefined, options);
    return dateFormatter.format(date);
  }
};
